import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStepForwards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"step-forwards,continue"} maskId="square-filled-radius-0-stroke-1-IconStepForwards"><path d="M17.5 2.79297L16.7929 3.50008L19.2929 6.00008H9.5C5.91015 6.00008 3 8.91022 3 12.5001C3 16.0899 5.91015 19.0001 9.5 19.0001H19V18.0001H9.5C6.46243 18.0001 4 15.5376 4 12.5001C4 9.46251 6.46243 7.00008 9.5 7.00008H19.2929L16.7929 9.50008L17.5 10.2072L21.2071 6.50008L17.5 2.79297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStepForwards;
